import React, { useState } from "react";
import Button from "../Button/Button";
import { DataPicker } from "../DataPicker/DataPicker";
import Typography from "../Typography/Typography";
import { Wrapper } from "./TransactionsBasedOnPersonsStyle";
import { AiOutlineDollar, AiOutlineProfile } from "react-icons/ai";
import { CgProfile } from "react-icons/cg";
import { Link } from "react-router-dom";
import {
  useFilterTransactionsBasedOnUser,
  useGetTransactionsBasedOnUser,
  useShowTag,
} from "../../hooks/useCrm";
import Loading from "../Loadings/LoadingTable";
import { formatDate } from "../../utils/formatDate";
import { SimpleSelect1 } from "../SimpleSelect/SimpleSelect1";
import { separate } from "../../utils/separate";
import BreadCrumb from "../BreadCrumb/BreadCrumb";
import { IoPersonOutline } from "react-icons/io5";
export const TransactionsBasedOnPersons = () => {
  const [tag, setTag] = useState("");
  const [isSort, setIsSort] = useState();

  const { data, isLoading } = useGetTransactionsBasedOnUser();
  const { data: tags } = useShowTag();
  const inputRef = null;
  const [status, setStatus] = useState("noFilter");
  const [form, setForm] = useState({
    Start: null,
    End: null,
  });
  const {
    mutateAsync: FilterTransactions,
    data: FilteredData,
    isLoading: FilteringTransactions,
  } = useFilterTransactionsBasedOnUser();
  const handleFilter = async (da) => {
    await FilterTransactions(da);
  };
  var FirstFactorSplitedPrice = 0;
  var FirstFactorSplitedFactors = 0;
  var fileLength = 0;
  const tagsOptions = tags?.data?.tags?.map((tag) => {
    return {
      value: tag.NameTag,
      label: tag.NameTag,
    };
  });
  const filterOptions = [
    {
      value: "بیشترین قیمت",
      label: "بیشترین قیمت",
    },
    { value: "بیشترین فاکتور", label: "بیشترین فاکتور" },
    { value: "فاکتور اول", label: "فاکتور اول" },
  ];
  const priceData = status === "noFilter" ? data?.data : FilteredData?.data;

  const File =
    status === "Filtered"
      ? FilteredData?.data?.AllUserScell
      : data?.data?.AllUserScell;

  const sortNames = () => {
    if (isSort === "بیشترین قیمت") {
      return File?.sort((a, b) => b?.DepositAllOne - a?.DepositAllOne);
    } else if (isSort === "بیشترین فاکتور") {
      return File?.sort((a, b) => b?.NumberList - a?.NumberList);
    } else if (isSort === "فاکتور اول") {
      // return File?.sort((a, b) => a?.NumberList - b?.NumberList);
      return File?.filter((item) => item.cotomerone === true);
    } else {
      return File?.sort((a, b) => (a?.FirstName > b?.FirstName ? -1 : 1));
    }
  };
  let firstFactorSum = 0;
  let firstFactorTransaction = 0;
  let firstFactorPerson = 0;
  let sumList = 0;
  let factorCount = 0;
  let customersLength = 0;
  const items = sortNames()
    ? sortNames()
        ?.filter((file, index) => {
          if (tag === file?.FactorTag) {
            return file;
          } else if (tag.length === 0) {
            return file;
          }
        })
        .map((item) => {
          firstFactorSum += parseInt(item?.SumList);
          firstFactorTransaction += parseInt(item?.NumberList);
          firstFactorPerson += 1;
          sumList += +item?.SumList;
          factorCount += item?.NumberList;
          customersLength += 1;

          return (
            <div className="mb-3 col-xl-3 col-lg-4 col-md-6">
              <Link
                to={`/dashboard/crm/customer-file/${item?.IdS0alesOpportunities}`}
              >
                <div className="user-card">
                  <Typography size="16px" className="d-flex">
                    <CgProfile
                      color={
                        item?.Status === "offline"
                          ? item?.NumberList === 1
                            ? "orange"
                            : "green"
                          : item?.NumberList === 1
                          ? "blue"
                          : "red"
                      }
                      size="20px"
                    />{" "}
                    نام مشتری:{" "}
                    <span
                      style={{
                        color:
                          item?.Status === "offline"
                            ? item?.NumberList === "1"
                              ? "orange"
                              : "green"
                            : item?.NumberList === "1"
                            ? "blue"
                            : "red",
                      }}
                    >
                      {item?.FirstName}
                    </span>
                  </Typography>
                  <Typography size="16px" className="d-flex">
                    <AiOutlineProfile size="20px" /> جمع فاکتورها:{" "}
                    {item?.NumberList}
                  </Typography>
                  <Typography className="d-flex">
                    <AiOutlineProfile size="20px" />{" "}
                    {status === "noFilter"
                      ? `فاکتور ماه جاری: ${parseInt(
                          item?.NumberDepositAllOnOne
                        ).toLocaleString()}`
                      : `فاکتور بازه انتخابی: ${parseInt(
                          item?.NumberDepositAllOnOne
                        ).toLocaleString()}`}
                  </Typography>
                  <Typography size="16px" className="d-flex">
                    <AiOutlineDollar size="20px" /> مبلغ کل فاکتورها:{" "}
                    {parseInt(item?.SumList).toLocaleString()}
                  </Typography>
                  <Typography className="d-flex">
                    <AiOutlineDollar size="20px" />{" "}
                    {status === "noFilter"
                      ? `مبلغ ماه جاری: ${parseInt(
                          item?.DepositAllOne
                        ).toLocaleString()}`
                      : `مبلغ بازه انتخابی: ${parseInt(
                          item?.DepositAllOne
                        ).toLocaleString()}`}
                  </Typography>
                  <Typography className="d-flex">
                    <IoPersonOutline size="20px" />
                    نحوه آشنایی: {item?.methodOfIntroduction}
                  </Typography>
                  <Typography className="d-flex">
                    <IoPersonOutline size="20px" />
                    استان: {item?.provinces}
                  </Typography>
                </div>
              </Link>
            </div>
          );
        })
    : null;

  return (
    <Wrapper className="mt-3">
      {!isLoading ? (
        <>
          <BreadCrumb
            margin="mt-3"
            num1="واحد CRM"
            num2="گزارشگیری"
            num3="معاملات بر اساس اشخاص"
            href1="/dashboard/crm"
            href2="/dashboard/crm/reporting"
          />
          <div className="mt-3 filterButtons row justify-content-evenly">
            <div className="mb-3 col-lg-2 col-md-5 col-sm-5 col-12 button button-inprogress">
              <Typography size="14px">
                تعداد معاملات جاری :{" "}
                {parseInt(
                  priceData?.NumberCurrentTradesorder_onlines
                ).toLocaleString()}
              </Typography>
              <Typography size="14px">
                کل مبلغ :{" "}
                {parseInt(
                  priceData?.SumCurrentTradesorder_onlines
                ).toLocaleString()}
              </Typography>
            </div>
            <div className="mb-3 col-lg-2 col-md-5 col-sm-5 col-12 button button-failed">
              <Typography size="14px">
                تعداد معاملات ناموفق :{" "}
                {parseInt(
                  priceData?.Numberorder_offlines_unsuccessfuls
                ).toLocaleString()}
              </Typography>
              <Typography size="14px">
                کل مبلغ :{" "}
                {parseInt(
                  priceData?.Sumorder_offlines_unsuccessfuls
                ).toLocaleString()}
              </Typography>
            </div>
            <div className="mb-3 col-lg-2 col-md-5 col-sm-5 col-12 button button-success-offline">
              <Typography size="14px">
                تعداد معاملات موفق آفلاین :{" "}
                {parseInt(priceData?.AllNumberorder_offlines).toLocaleString()}
              </Typography>
              <Typography size="14px">
                کل مبلغ :{" "}
                {parseInt(priceData?.Sumorder_offlines).toLocaleString()}
              </Typography>
            </div>
            <div className="mb-3 col-lg-2 col-md-5 col-sm-5 col-12 button button-success-online ">
              <Typography size="14px">
                تعداد معاملات موفق آنلاین :{" "}
                {parseInt(priceData?.Numberorder_onlines).toLocaleString()}
              </Typography>
              <Typography size="14px">
                کل مبلغ :{" "}
                {parseInt(priceData?.Sumorder_onlines).toLocaleString()}
              </Typography>
            </div>
            <div className="mb-3 col-lg-2 col-md-5 col-sm-5 col-12 button button-all-orders">
              <Typography size="14px">
                تعداد کل معاملات :{" "}
                {(
                  parseInt(priceData?.AllNumberorder_offlines) +
                  parseInt(priceData?.Numberorder_onlines)
                ).toLocaleString()}
              </Typography>
              <Typography size="14px">
                کل مبلغ :{" "}
                {(
                  parseInt(priceData?.Sumorder_offlines) +
                  parseInt(priceData?.Sumorder_onlines)
                ).toLocaleString()}
              </Typography>
            </div>
          </div>
          <div className="timespan row ">
            <div className="mb-2 col-lg-2">
              <DataPicker
                onChange={(e) => setForm({ ...form, Start: formatDate(e) })}
                label="بازه ابتدائی"
              />
            </div>
            <div className="mb-2 col-lg-2">
              <DataPicker
                onChange={(e) => setForm({ ...form, End: formatDate(e) })}
                label="بازه انتهایی"
              />
            </div>
            <div className="col-lg-2">
              <SimpleSelect1
                res={tagsOptions}
                label="برچسب ها"
                onChange={(e) => {
                  if (!e) {
                    e = {
                      target: inputRef,
                      value: "",
                    };
                  }
                  setTag(e.value);
                }}
              />
            </div>
            <div className="col-lg-2">
              <SimpleSelect1
                res={filterOptions}
                label="فیلترها"
                onChange={(e) => {
                  if (!e) {
                    e = {
                      target: inputRef,
                      value: "",
                    };
                  }
                  if (e.value === "بیشترین قیمت") {
                    setIsSort("بیشترین قیمت");
                  } else if (e.value === "بیشترین فاکتور") {
                    setIsSort("بیشترین فاکتور");
                  } else if (e.value === "فاکتور اول") {
                    setIsSort("فاکتور اول");
                  } else {
                    setIsSort("");
                  }
                }}
              />
            </div>
            <div className="pt-2 mt-4 col-lg-4">
              <Button
                bgColor="#009ef7"
                color="#fff"
                className="m-0"
                small="fit-content"
                size="12px"
                onclick={() => {
                  handleFilter(form);
                  setStatus("Filtered");
                }}
              >
                اعمال فیلتر
              </Button>
              <Button
                bgColor="#f1416c"
                color="#fff"
                className="m-0 mx-1"
                small="fit-content"
                size="12px"
                onclick={() => setStatus("noFilter")}
              >
                حذف فیلتر
              </Button>
            </div>

            <div className="col-12">
              <Typography className="mt-3">
                {/* مبلغ کل:{" "}
                {sumList
                  ? separate(sumList)
                  : isSort === "فاکتور اول"
                  ? separate(firstFactorSum)
                  : !FilteringTransactions
                  ? FirstFactorSplitedPrice !== 0
                    ? FirstFactorSplitedPrice.toLocaleString()
                    : parseInt(
                        status === "Filtered"
                          ? FilteredData?.data.AllSum
                          : status === "noFilter"
                          ? data?.data?.AllSum
                          : ""
                      ).toLocaleString()
                  : ""}{" "} */}
                {/* تعداد کل معاملات:{" "}
                {factorCount
                  ? separate(factorCount)
                  : isSort === "فاکتور اول"
                  ? separate(firstFactorTransaction)
                  : FirstFactorSplitedFactors
                  ? FirstFactorSplitedFactors.toLocaleString()
                  : status === "Filtered"
                  ? FilteredData?.data.AllNumber
                  : status === "noFilter"
                  ? data?.data?.AllNumber
                  : ""}{" "} */}
                تعداد کل اشخاص:{" "}
                {customersLength
                  ? separate(customersLength)
                  : isSort === "فاکتور اول"
                  ? firstFactorPerson
                  : fileLength > 0
                  ? FirstFactorSplitedFactors
                  : status === "Filtered"
                  ? FilteredData?.data.AllNumberUser
                  : status === "noFilter"
                  ? data?.data?.AllNumberUser
                  : ""}
              </Typography>
            </div>
          </div>
          <div className="mt-3 row">
            {!FilteringTransactions ? items : <Loading />}
          </div>
        </>
      ) : (
        <Loading />
      )}
    </Wrapper>
  );
};
